var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "favorite-active",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E0B0B",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4069 27.984C25.5464 28.8039 24.9996 29.5825 24.1856 29.723C23.8616 29.7789 23.5284 29.7257 23.2374 29.5717L16.1255 25.807L9.01923 29.5762C8.28849 29.9638 7.38418 29.6813 6.9994 28.9452C6.84606 28.6519 6.79307 28.3158 6.84865 27.989L8.20684 20.0046L2.45043 14.3404C1.85967 13.7591 1.84858 12.8054 2.42567 12.2103C2.6551 11.9738 2.95545 11.8198 3.28037 11.7723L11.2275 10.6093L14.7836 3.34076C15.1487 2.59456 16.0451 2.28776 16.7859 2.6555C17.0814 2.8022 17.3206 3.04309 17.4662 3.34076L21.0223 10.6093L28.9694 11.7723C29.7867 11.8919 30.353 12.6562 30.2343 13.4794C30.1871 13.8067 30.0342 14.1093 29.7994 14.3404L24.0486 19.9989L25.4069 27.984Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteActive);
export default __webpack_public_path__ + "static/media/FavoriteActive.3be0dff89a8ee315f4ef64727afdef24.svg";
export { ForwardRef as ReactComponent };